module.exports = "/_next/static/images/seo-image-1x-507a26acdd3fba8f86cf791f476fa305.png.webp";